import { curry } from 'lib/util'
import { set } from 'app/_shared/events/notification/alert'

/**
 * Sets the notification adapters group data to the fetched data
 *
 * @param {Function} callback                 callback to execute
 * @param {Gaia.AppModule.Spec} module        module composition
 * @param {Gaia.Component.Spec} component     action component
 * @param {Gaia.AppModule.EventHandler} event triggered event
 * @returns {Promise<void>}
 * @private
 */
const _set = async (callback, module, component, event) => {
  const { data, page } = event?.detail || event || {}

  await set(module, component, { data, page }, callback, event)
}

export default curry(_set)
